define(function (require) {
    "use strict";

    var LE = require("app");
    var ContentSystemMessagingModel = require("content-models/system-messaging/ContentSystemMessagingModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var ContentSystemMessagingUtilities = require("content-utils/ContentSystemMessagingUtilities");

    var SystemMessagingDefaultsCollection = {};
    var NAME = "SystemMessagingDefaultsCollection";

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        SystemMessagingDefaultsCollection = RevisionedCollection.extend({
            name: NAME,
            model: ContentSystemMessagingModel,
            resource: ApiResources.AccountConfig.SystemMessagingDefaults,

            comparator: function (model) {
                return model.id;
            },

            parse: function(resp, options) {
                var parsedResp = [];
                _.each(resp, function (message) {
                    if(!ContentSystemMessagingUtilities.isMessageDiscontinued(message.id)){
                        parsedResp.push(message);
                    }
                }, this);

                return RevisionedCollection.prototype.parse.call(this, parsedResp, options);
            }
        });
    });

    SystemMessagingDefaultsCollection.NAME = NAME;

    return SystemMessagingDefaultsCollection;
});
